<template>
    <div>
        <section v-if="auth.user" class="container-fluid">
            <div class="row position-relative">
                <h1 class="titre1 mt-4">
                    Liste des sociétés
                </h1>
            </div>
            <div class="row">
                <b-button v-b-modal.modal-entreprise class="ml-3"><i class="fas fa-plus-circle ml-1"></i> Créer une société</b-button>
            </div>
            <div class="table-responsive mt-1">
                <b-table id="entreprises-table" hover small :items="listeEntreprises" :fields="colonnes" :tbody-tr-class="rowClass" class="align-middle">
                    <template #cell(statut)="row">
                        <b-dropdown size="sm" :variant="row.item.statut == 'Bloqué' ? 'danger' : (row.item.statut == 'Alerte' ? 'warning' : 'light')">
                            <template #button-content>
                                {{ row.item.statut }}
                            </template>
                            <b-dropdown-item 
                                v-for="statut in statuts" :key="statut"
                                @click="updateStatut(row.item, statut)">
                                {{ statut }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                    <template #cell(nom)="row">
                        <div v-if="row.item.id != editableEntreprise" @click="editEntreprise(row.item.id)" class="w-100">{{ row.item.nom }}</div>
                        <input v-else ref="nom" v-model="row.item.nom" v-on:focusout="updateNom(row.item)" class="w-100"/>
                    </template>
                    <template #cell(delete)="row">
                        <b-button v-if="row.item.users_count == 0" variant="danger" @click="confirmDeleteEntreprise(row.item)" size="sm">
                            <i class="fas fa-trash"></i>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </section>
        <b-modal id="modal-entreprise" title="Créer une nouvelle société" @ok="validateModalEntreprise" @hidden="nomNouvelleEntreprise = ''">
            <div class="row p-2">
                <b-form-group
                class="col-12"
                label="Nom de la société"
                label-for="entreprise_nom"
                >
                <b-form-input id="entreprise_nom" v-model="nomNouvelleEntreprise" trim></b-form-input>
                </b-form-group>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Societes",

  data() {
    return {
        loading: false,
        listeEntreprises: [],
        editableEntreprise: 0,
        nomNouvelleEntreprise: "",
        statuts : ['RAS', 'Alerte', 'Bloqué'],
        colonnes:[
            {key: 'nom', label: 'Nom', sortable: true},
            {key: 'statut', label: 'Statut', sortable: true},
            {key: 'users_count', label: '# utilisateurs', sortable: true},
            {key: 'delete', label: '', sortable: false},
        ],
    }
  },

  computed: {
    ...mapGetters([
      'auth',
    ]),
  },

  mounted() {
    if(this.auth.user && this.auth.user.roles && this.auth.user.roles.find(role => (role.name == 'admin' || role.name == 'super-admin'))) {
        this.refresh()
    } else {
        this.$router.push('/')
    }
  },

  methods: {
    ...mapActions([
      'entreprises', 'updateEntreprise', 'createEntreprise', 'deleteEntreprise'
    ]),
    confirmDeleteEntreprise(entreprise) {
        this.$bvModal.msgBoxConfirm('Etes vous sûr de vouloir supprimer "'+entreprise.nom+'"?', {okTitle: 'Oui, supprimer', cancelTitle: 'Non, annuler', okVariant: 'danger'})
            .then(confirmation => {
                if(confirmation) {
                    this.deleteEntreprise(entreprise).then((response) => {
                        this.showToast("Société supprimée");
                        this.refresh();
                    });
                }
            })
    },
    validateModalEntreprise() {
      if(this.nomNouvelleEntreprise.length > 0 && undefined === this.listeEntreprises.find(e => e.nom === this.nomNouvelleEntreprise)) {
        this.createEntreprise({nom: this.nomNouvelleEntreprise}).then((response) => {
          this.showToast("Société créée");
          this.refresh();
        });
      } else {
        this.showToast("Cette société existe déjà");
      }
    },
    updateStatut(entreprise, statut) {
        console.log(entreprise)
        entreprise.statut = statut;
        this.updateEntreprise(entreprise);
    },
    updateNom(entreprise) {
        this.editableEntreprise = 0;
        if(entreprise.nom.length > 0 && undefined === this.listeEntreprises.find(e => (e.nom === entreprise.nom && e.id !== entreprise.id))) {
            this.updateEntreprise(entreprise);
        } else {
            this.showToast("Cette société existe déjà");
            this.refresh();
        }
    },
    editEntreprise(id) {
        this.editableEntreprise = id;
        this.$nextTick(() => this.$refs.nom.focus());
    },
    rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.statut === 'Alerte') return 'table-warning'
        if (item.statut === 'Bloqué') return 'table-danger'
        return
    },
    refresh() {
      this.entreprises().then((response) => {
        this.listeEntreprises = response
      })
    },
    showToast(message) {
      this.$toasted.show(message, {
        theme: "outline",
        position: "bottom-center",
        duration : 2000
      });
    },
  },
}
</script>

<style>
#entreprises-table > tbody > tr > td {
    vertical-align: middle;
}
</style>